import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lik-opo',
  templateUrl: './lik-opo.component.html',
  styleUrls: ['./lik-opo.component.scss']
})
export class LikOpoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
